import { escape as escapeHtml } from 'lodash';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import { useRootStore } from '@/stores/RootStore';
import type { AppAlert } from '@/types/alerts';

/* BittsBanner renders the message as HTML, so the incident text is escaped */
export default function useStatusIncidentAlerts() {
  const { statusPageIncidents } = storeToRefs(useRootStore());

  const statusIncidentAlerts = computed(() =>
    statusPageIncidents.value.map(
      (incident) =>
        ({
          icon: ['fak', 'warning'],
          message: `${escapeHtml(incident.name)}. <a href="${escapeHtml(incident.url)}" target="_blank" rel="noopener noreferrer">View status</a>`,
          type: 'status-incident',
        }) satisfies AppAlert,
    ),
  );

  return { statusIncidentAlerts };
}
